<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Earnings</h2>

      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a routerLink="dashboard" href="javascript:void(0);">
              <i class="ti ti-smart-home"></i>
            </a>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Earnings</li>
        </ol>
      </nav>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <hr />

  <!-- Summary Cards -->
  <div class="row">
    <!-- Total Earnings -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-dark rounded-circle">
                <i class="ti ti-currency-rupee"></i>
              </span>
            </div>

            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Total Earnings</p>
              <h4>{{ totalAmount || 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Successful -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-success rounded-circle">
                <i class="ti ti-check"></i>
              </span>
            </div>

            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Successful</p>
              <h4>{{ successfulCount || 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-warning rounded-circle">
                <i class="ti ti-clock"></i>
              </span>
            </div>

            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Pending</p>
              <h4>{{ pendingCount || 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Failed -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <span class="avatar avatar-lg bg-danger rounded-circle">
                <i class="ti ti-x"></i>
              </span>
            </div>

            <div class="ms-2 overflow-hidden">
              <p class="fs-12 fw-medium mb-1 text-truncate">Failed</p>
              <h4>{{ failedCount || 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Earnings List -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Earnings List</h5>

      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <!-- Page Limit -->
        <div class="me-3">
          <select
            data-extension-safe
            class="form-select form-select-sm"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
              {{ limit }}
            </option>
          </select>
        </div>

        <!-- Business Filter -->
        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [(ngModel)]="businessId"
          (change)="onBusinessChange()"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <!-- Status Filter -->
        <div class="dropdown me-3">
          <select class="form-select" [(ngModel)]="status" (change)="onStatusChange()">
            <option [ngValue]="null">Select Status</option>

            <option value="success">Success</option>

            <option value="pending">Pending</option>

            <option value="failed">Failed</option>
          </select>
        </div>

        <!-- Search Payment Gateway ID -->
        <div class="form-sort search-box">
          <label>
            <!-- <input
              type="search"
              class="form-control"
              placeholder="Search Payment Gateway ID"
              [(ngModel)]="search"
              (input)="loadEarnings(); setCurrentPage()"
            /> -->
            <input
              type="text"
              class="form-control"
              [(ngModel)]="search"
              (ngModelChange)="onSearch($event)"
              placeholder="Search..."
            />
          </label>
        </div>
      </div>
    </div>

    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <!-- <ng-container *ngIf="earnings$ | async as earnings"> -->
        <!-- Table -->
        <table class="table datatable" *ngIf="earnings.length > 0; else noRecords">
          <thead class="thead-light">
            <tr>
              <th>Payment For</th>
              <th>Payment Gateway ID</th>
              <th>Business Name</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Payment Method</th>
              <th>Paid On</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let earning of earnings">
              <td>
                <div class="d-flex align-items-center gap-2">
                  <i class="ti ti-file-invoice fs-18"></i>

                  <div class="d-flex flex-column">
                    <span class="fw-medium">
                      {{ getPaymentPurpose(earning) }}
                    </span>

                    <small class="text-muted" *ngIf="earning?.['paymentResponse']?.description">
                      {{ earning?.['paymentResponse']?.description }}
                    </small>
                  </div>
                </div>
              </td>
              <!-- Payment Gateway ID -->
              <td>
                <span class="fw-medium">
                  {{ earning.gatewayPaymentId || 'N/A' }}
                </span>
              </td>

              <!-- Business Name -->
              <td>
                {{
                  earning.business?.businessName
                    ? (earning.business?.businessName | capitalize)
                    : 'N/A'
                }}
              </td>

              <!-- Amount -->
              <td>
                <span class="fw-semibold"> ₹{{ earning.amount || 0 }} </span>
              </td>

              <!-- Status -->
              <td>
                <span
                  *ngIf="earning.status === 'success'"
                  class="badge badge-success d-inline-flex align-items-center badge-xs"
                >
                  <i class="ti ti-check me-1"></i>
                  Success
                </span>

                <span
                  *ngIf="earning.status === 'pending'"
                  class="badge badge-warning d-inline-flex align-items-center badge-xs"
                >
                  <i class="ti ti-clock me-1"></i>
                  Pending
                </span>

                <span
                  *ngIf="earning.status === 'failed'"
                  class="badge badge-danger d-inline-flex align-items-center badge-xs"
                >
                  <i class="ti ti-x me-1"></i>
                  Failed
                </span>

                <span
                  *ngIf="
                    earning.status !== 'success' &&
                    earning.status !== 'pending' &&
                    earning.status !== 'failed'
                  "
                  class="badge badge-secondary d-inline-flex align-items-center badge-xs"
                >
                  {{ earning.status || 'N/A' }}
                </span>
              </td>

              <!-- Payment Method -->
              <!-- <td>
                  {{ earning.paymentMethod ? (earning.paymentMethod | capitalize) : 'N/A' }}
                </td> -->
              <td>
                <ng-container *ngIf="earning?.['paymentResponse'] as details; else noPayment">
                  <!-- CARD -->
                  <ng-container *ngIf="details?.['method'] === 'card'">
                    <div class="d-flex align-items-center gap-2">
                      <i class="ti ti-credit-card fs-18"></i>

                      <div class="d-flex flex-column">
                        <span>
                          {{ details?.['card']?.['network'] || 'Card' | capitalize }}

                          <ng-container *ngIf="details?.['card']?.['last4']">
                            **** {{ details?.['card']?.['last4'] }}
                          </ng-container>
                        </span>

                        <small class="text-muted">
                          {{ details?.['card']?.['type'] | capitalize }}

                          <ng-container *ngIf="details?.['card']?.['issuer']">
                            · {{ details?.['card']?.['issuer'] }}
                          </ng-container>
                        </small>
                      </div>
                    </div>
                  </ng-container>

                  <!-- UPI -->
                  <ng-container *ngIf="details?.['method'] === 'upi'">
                    <div class="d-flex align-items-center gap-2">
                      <i class="ti ti-brand-google-drive fs-18"></i>

                      <div class="d-flex flex-column">
                        <span>UPI</span>

                        <small class="text-muted" *ngIf="details?.['vpa']">
                          {{ details?.['vpa'] }}
                        </small>
                      </div>
                    </div>
                  </ng-container>

                  <!-- NET BANKING -->
                  <ng-container *ngIf="details?.['method'] === 'netbanking'">
                    <div class="d-flex align-items-center gap-2">
                      <i class="ti ti-building-bank fs-18"></i>

                      <div class="d-flex flex-column">
                        <span>Net Banking</span>

                        <small class="text-muted" *ngIf="details?.['bank']">
                          {{ details?.['bank'] }}
                        </small>
                      </div>
                    </div>
                  </ng-container>

                  <!-- WALLET -->
                  <ng-container *ngIf="details?.['method'] === 'wallet'">
                    <div class="d-flex align-items-center gap-2">
                      <i class="ti ti-wallet fs-18"></i>
                      <span>Wallet</span>
                    </div>
                  </ng-container>

                  <!-- OTHER -->
                  <ng-container
                    *ngIf="
                      details?.['method'] !== 'card' &&
                      details?.['method'] !== 'upi' &&
                      details?.['method'] !== 'netbanking' &&
                      details?.['method'] !== 'wallet'
                    "
                  >
                    <span>
                      {{ details?.['method'] | capitalize }}
                    </span>
                  </ng-container>
                </ng-container>

                <ng-template #noPayment>
                  <span class="text-muted">N/A</span>
                </ng-template>
              </td>

              <td>
                <div class="d-flex flex-column">
                  <span class="fw-medium">
                    {{ earning.createdAt | date: 'dd MMM yyyy' }}
                  </span>

                  <small class="text-muted">
                    {{ earning.createdAt | date: 'hh:mm a' }}
                  </small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- </ng-container> -->

        <!-- No Records -->
        <ng-template #noRecords>
          <div class="text-center p-4">Record not available</div>
        </ng-template>
      </div>
    </div>

    <!-- Pagination -->
    <!-- <ng-container *ngIf="earnings$ | async as earnings"> -->
    <div class="d-flex align-items-center justify-content-between ms-2" *ngIf="earnings.length > 0">
      <div>
        Showing
        {{ (currentPage - 1) * pageLimit + 1 }}
        to
        {{ pageLastRecord }}
        of
        {{ totalCount }}
        entries
      </div>

      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
    <!-- </ng-container> -->
    <!-- /Pagination -->
  </div>
</div>
